import {createReducer, on} from '@ngrx/store';
import {BackgroundTaskActions} from './background-task.actions';
import {initialBackgroundTaskState} from './background-task.state';

export const backgroundTaskReducer = createReducer(
  initialBackgroundTaskState,

  on(BackgroundTaskActions.loadPendingTasks, (state) => ({
    ...state,
    isLoading: true
  })),

  on(BackgroundTaskActions.loadPendingTasksSuccess, (state, {tasks}) => ({
    ...state,
    pendingTasks: tasks,
    isLoading: false,
    error: null
  })),

  on(BackgroundTaskActions.loadPendingTasksFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error
  })),

  on(BackgroundTaskActions.loadTasks, (state) => ({
    ...state,
    isLoading: true
  })),

  on(BackgroundTaskActions.loadTasksSuccess, (state, {tasks}) => ({
    ...state,
    allTasks: tasks,
    isLoading: false,
    error: null
  })),

  on(BackgroundTaskActions.loadTasksFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error
  })),

  on(BackgroundTaskActions.taskCompleted, (state, {task}) => ({
    ...state,
    pendingTasks: state.pendingTasks.filter(t => t.id !== task.id),
    completedNotifications: [...state.completedNotifications, task]
  })),

  on(BackgroundTaskActions.clearCompletedNotification, (state, {taskId}) => ({
    ...state,
    completedNotifications: state.completedNotifications.filter(t => t.id !== taskId)
  }))
);
